import React from 'react';
import Badge from '../ui/Badge';
import { Table, TBody, TH, THead, TR, TD, TableScroller } from '../ui/Table';
import { changeTypeBadge, displayValue } from '../../utils/commandCenterHelpers';

// Field-level change log for a single version.
// Columns: ID, Name, Change Type, Field, Previous, New, Details.
export default function ChangeLogTable({ changeLogs }) {
  if (!changeLogs || changeLogs.length === 0) {
    return (
      <p className="px-3 py-3 text-[12.5px] text-slate-400 italic">
        No field-level changes recorded for this version.
      </p>
    );
  }

  return (
    <TableScroller className="rounded-lg border border-slate-100">
      <Table>
        <THead>
          <TR hoverable={false}>
            <TH>ID</TH>
            <TH>Name</TH>
            <TH>Change type</TH>
            <TH>Field</TH>
            <TH>Previous</TH>
            <TH>New</TH>
            <TH>Details</TH>
          </TR>
        </THead>
        <TBody>
          {changeLogs.map((log) => {
            const badge = changeTypeBadge(log.changeType);
            return (
              <TR key={log.id}>
                <TD className="font-mono text-[11.5px] text-slate-500">
                  {log.refId || '—'}
                </TD>
                <TD className="text-slate-700">{log.refName || '—'}</TD>
                <TD>
                  <Badge variant={badge.variant} size="sm">
                    {badge.label}
                  </Badge>
                </TD>
                <TD className="text-slate-600">{log.fieldChanged || '—'}</TD>
                <TD className="text-slate-400 max-w-[160px] truncate" title={displayValue(log.oldValue)}>
                  {displayValue(log.oldValue)}
                </TD>
                <TD
                  className="text-slate-900 font-medium max-w-[160px] truncate"
                  title={displayValue(log.newValue)}
                >
                  {displayValue(log.newValue)}
                </TD>
                <TD className="text-[12px] text-slate-500 max-w-[200px] truncate" title={log.details}>
                  {log.details || '—'}
                </TD>
              </TR>
            );
          })}
        </TBody>
      </Table>
    </TableScroller>
  );
}
